<template tag="클라이언트 검색 컴포넌트">
  <template v-if="!isMobile">
    <v-select
      ref="selectRef"
      v-model="modelValue"
      :items="filteredItems"
      item-title="name"
      :placeholder="placeholder"
      :disabled="disabled"
      :no-data-text="notext"
      class="form_style select_box sch_select_box wd_p100"
      :menu-props="{ contentClass: 'combobox_overlay sch_overlay' }"
      @update:model-value="onSelect"
      density="compact"
      variant="plain"
    >
      <!--  검색창 -->
      <template #prepend-item>
        <div class="search_input" @mousedown.stop @click.stop @keydown.stop>
          <Base.Input
            v-model="searchValue"
            type="search"
            :placeholder="schPlaceholder"
            hide-details
            @input="onSearch"
            @keydown.stop
          />
          <Base.Button icon="btn_search" txt="none" @click.stop="onSearch" />
        </div>
      </template>

      <!-- 리스트 -->
      <template #item="{ props, item }">
        <v-list-item
          v-bind="props"
          class="sch_result"
          :class="{ selected: modelValue === item.raw.name }"
        ></v-list-item>
      </template>
    </v-select>
  </template>
  <template v-if="isMobile">
    <div class="sch_overlay">
      <div class="search_input wd_p100" @mousedown.stop @click.stop @keydown.stop>
        <Base.Input
          v-model="searchValue"
          type="search"
          :placeholder="schPlaceholder"
          hide-details
          @input="onSearch"
          @keydown.stop
        />
        <Base.Button icon="btn_search" txt="none" @click.stop="onSearch" />
      </div>
      <div class="sch_overlay_list">
        <v-list>
          <v-list-item
            v-for="item in filteredItems"
            :key="item.id"
            class="sch_result"
            :class="{ selected: modelValue === item.name }"
            @click="onSelect(item.name)"
          >
            {{ item.name }}
          </v-list-item>

          <div v-if="filteredItems.length === 0" class="m_no_data">
            {{ notext }}
          </div>
        </v-list>
      </div>
    </div>
  </template>
</template>

<script setup>
import { ref, computed, defineProps, onMounted, onUnmounted } from "vue";
import { Base } from "../BaseFactory";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const modelValue = defineModel();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  items: { type: Array, default: () => [] },
  placeholder: { type: String, default: "" },
  schPlaceholder: { type: String, default: "검색어를 입력해 주세요." },
  disabled: { type: Boolean, default: false },
  notext: { type: String, default: "일치하는 결과가 없습니다." },
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
const selectRef = ref(null);
const searchValue = ref("");
const width = ref(window.innerWidth); // 리사이즈

/* ------------------------------------------------------------
                          Computed Properties
   ------------------------------------------------------------ */
const isMobile = computed(() => width.value <= 768);
const filteredItems = computed(() => {
  if (!searchValue.value) return props.items;
  return props.items.filter((x) => x.name.toLowerCase().includes(searchValue.value.toLowerCase()));
});

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
const onSearch = () => {};

const onSelect = (value) => {
  modelValue.value = value;
  searchValue.value = "";
};

const handleResize = () => {
  width.value = window.innerWidth;
};

/* ------------------------------------------------------------
                          Lifecycle
   ------------------------------------------------------------ */
onMounted(() => {
  window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>
